export enum FeatureFlags {
  NEW_DR_SCRIPT = 'new-dr-script',
  DR_EXHIBITS = 'DRExhibits',
}
